var isHash = function (hash) {
    if (typeof window !== 'undefined') {
        return window.location.hash === "#".concat(hash);
    }
    return false;
};
export default isHash;
